module.exports = __webpack_public_path__ + "img/icon_guangzhao.e4adf5e7.png";